import React, { useRef } from "react";

/**
 * Glass card with cursor-tracking ambient glow.
 * The glow follows the mouse, creating a tactile, premium hover.
 */
export default function CursorGlowCard({
  children,
  className = "",
  glowColor = "rgba(0, 170, 255, 0.18)",
  as: Component = "div",
  ...rest
}) {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    el.style.setProperty("--cx", `${x}%`);
    el.style.setProperty("--cy", `${y}%`);
  };

  return (
    <Component
      ref={ref}
      onMouseMove={handleMove}
      className={`relative glass overflow-hidden transition-all duration-500 ${className}`}
      style={{ "--cx": "50%", "--cy": "50%" }}
      {...rest}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500"
        style={{
          background: `radial-gradient(circle 280px at var(--cx) var(--cy), ${glowColor}, transparent 60%)`,
        }}
      />
      {children}
    </Component>
  );
}
